import styled from "styled-components";
import { prettyPrintJson } from "../utils";
import { useTheme } from "../contexts/ThemeProvider";

const Container = styled.pre<any>`
  color: white;
  background-color: ${({ isDark }) => isDark ? '#131311' : '#272822'};
  border: 1px solid rgba(101, 101, 101, 0.25);
  padding: 10px 20px;
  border-radius: 4px;
  width: 100%;
  max-height: 500px;
  font-size: 12px;
`;

function CodeView(props: { jsonString?: string }) {
  const { currentTheme } = useTheme();

  return (
    <Container isDark={currentTheme === 'dark'}>
      <code dangerouslySetInnerHTML={{ __html: prettyPrintJson(props.jsonString || '') }} />
    </Container>
  )
}

export default CodeView;
